__turbopack_context__.v({
  "tile": "CategoryTiles-module-scss-module__yq03pW__tile",
  "tile__count": "CategoryTiles-module-scss-module__yq03pW__tile__count",
  "tile__image": "CategoryTiles-module-scss-module__yq03pW__tile__image",
  "tile__image-link": "CategoryTiles-module-scss-module__yq03pW__tile__image-link",
  "tile__name": "CategoryTiles-module-scss-module__yq03pW__tile__name",
  "tile__placeholder": "CategoryTiles-module-scss-module__yq03pW__tile__placeholder",
  "tile__stub": "CategoryTiles-module-scss-module__yq03pW__tile__stub",
  "tiles": "CategoryTiles-module-scss-module__yq03pW__tiles",
  "tiles__grid": "CategoryTiles-module-scss-module__yq03pW__tiles__grid",
  "tiles__heading": "CategoryTiles-module-scss-module__yq03pW__tiles__heading",
});
